
import { toast } from "react-toastify";
import * as signalR from "@microsoft/signalr";

import { useCallback, useContext, useEffect, useState, useRef } from 'react';


export default function useSignalR(url, handlers = {}, onReconnected) {
  const [connection, setConnection] = useState(null);
  const connectionRef = useRef(null);
  const handlersRef = useRef(handlers);
  // فقط یک‌بار handlers رو ذخیره کن
  useEffect(() => {
    handlersRef.current = handlers;
  }, []);
  const shouldRetry = (error) => {
    if (!error) return true;
    const msg = error.message || "";
    return !msg.includes("401") && !msg.includes("404");
  };
  const connectionStart = useCallback(async (fromOnClose) => {
    const current = connectionRef.current;
    // جلوگیری از اتصال مجدد غیرضروری
    if (
      current &&
      (current.state === signalR.HubConnectionState.Connected ||
        current.state === signalR.HubConnectionState.Connecting ||
        current.state === signalR.HubConnectionState.Reconnecting)
    ) {
      console.log('⏸ اتصال در حال حاضر برقرار یا در حال اتصال است');
      return;
    }
    //await stopPreviousConnection();
    try {
      const newConnection = new signalR.HubConnectionBuilder()
        .withUrl(url, {
          logMessageContent: true,
          logger: signalR.LogLevel.Error,
          //transport: signalR.HttpTransportType.WebSockets | signalR.HttpTransportType.LongPolling,
        })
        .withAutomaticReconnect({//[0, 1000, 2000, 5000]
          nextRetryDelayInMilliseconds: (retryContext) => { return 2000; }
          //(ctx) => Math.min(ctx.previousRetryCount * 2000, 3000),
        })
        .configureLogging(signalR.LogLevel.Information)
        .build();
      // ثبت متدها قبل از start()
      Object.entries(handlersRef.current).forEach(([event, handler]) => {
        newConnection.on(event, handler);
      });
      newConnection.onclose((error) => {
        console.log('🔌 اتصال قطع شد:', error);
        if (error && shouldRetry(error)) {
          setTimeout(() => {
            connectionStart(true); // تلاش مجدد دستی
          }, 2000);
        }
      });

      newConnection.onreconnecting((error) => {
        console.log('🔄 در حال تلاش برای اتصال مجدد:', error);
      });

      newConnection.onreconnected((connectionId) => {
        console.log('✅ اتصال مجدد موفق:', connectionId);
        if (onReconnected)
          onReconnected(newConnection, connectionId)
        else
          console.log('❌ عدم مقدار دهی onReconnect')

      });

      await newConnection.start();
      console.log('� اتصال جدید برقرار شد');
      connectionRef.current = newConnection;
      setConnection(newConnection);
      if (fromOnClose && onReconnected)
        onReconnected(newConnection)
    } catch (error) {
      console.error('❌ خطا در شروع اتصال:', error);
    }
  }, [url]);

  const connectionStop = useCallback(async () => {
    const current = connectionRef.current;
    if (current && current.state !== signalR.HubConnectionState.Disconnected) {
      try {
        await current.stop();
        console.log('🛑 اتصال متوقف شد');
      } catch (err) {
        console.error('❌ خطا در توقف اتصال:', err);
      }
    }
    // حذف متدهای ثبت‌شده
    if (connectionRef.current) {
      Object.keys(handlersRef.current).forEach((event) => {
        connectionRef.current.off(event);
      });
    }
    connectionRef.current = null;
    setConnection(null);
  }, []);


  useEffect(() => {
    connectionStart();
    return () => { connectionStop(); };
  }, [connectionStart, connectionStop]);
  return { connection, connectionStart, connectionStop };
}

